import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const dropedCompleteSurveyUsersAction = createAsyncThunk(
    'droped-completed-survey-users',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/support-server/api/droped-completed-survey-users`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const dropedCompleteSurveyUsersSlice = createSlice({
    name: 'droped-completed-survey-users',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(dropedCompleteSurveyUsersAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(dropedCompleteSurveyUsersAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(dropedCompleteSurveyUsersAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const dropedCompleteSurveyUsersReducer = dropedCompleteSurveyUsersSlice.reducer    